import { render, staticRenderFns } from "./LocaleSwitcher.component.vue?vue&type=template&id=6ca1d08c&"
import script from "./LocaleSwitcher.component.vue?vue&type=script&lang=ts&"
export * from "./LocaleSwitcher.component.vue?vue&type=script&lang=ts&"
import style0 from "./LocaleSwitcher.component.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAvatar,VFlex,VListItemAvatar,VListItemContent,VListItemTitle,VSelect})
